import { Injectable, Injector } from '@angular/core';
import { MeasurementDto, MeasurementQueryDto, MeasurementSerieDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { PagedResultDto } from '@common-modules/shared/model/paged-result.dto';
import { GridODataService } from '@common-modules/shared/odata/grid-odata.service';
import { Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TelemetryPointsService extends GridODataService<MeasurementDto> {
  private readonly _measurements$ = new ReplaySubject<MeasurementDto[]>(1);
  readonly measurements$ = this._measurements$.asObservable();

  constructor(injector: Injector) {
    super(injector, '/api/telemetry/measurement');
  }

  protected mapResponse(response: PagedResultDto<MeasurementDto>): PagedResultDto<MeasurementDto> {
    return response;
  }

  load(scenarioIds: string[]): Observable<any> {
    return this.getAllMeasurementByScenarioIds(scenarioIds).pipe(
      tap((measurements) => {
        this._measurements$.next(measurements);
      }),
    );
  }

  getAllMeasurementByScenarioIds(scenarioIds: string[]): Observable<MeasurementDto[]> {
    return this.httpCacheClient.get(
      `${this.baseUrl}${this.api}/scenarios`,
      { avoid: false },
      {
        $count: false,
        scenarioIds,
      },
    );
  }

  getMeasurementSerie(measurementQuery: MeasurementQueryDto[]): Observable<MeasurementSerieDto[]> {
    return this.httpCacheClient.post(`${this.baseUrl}${this.api}/serie`, measurementQuery, { avoid: false });
  }
}
